import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";

const EditUserModal = ({ handleEditModalClose, data, onUpdate }) => {
  const [rowId, setRowId] = useState("");
  const [userName, setUserName] = useState("");
  const [imagePreview, setImagePreview] = useState("");

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // console.log(data)
    // console.log(data.username)
    // console.log(data.email)
    if (data) {
      setRowId(data.id);
      setUserName(
        data.username ||
          data.name ||
          `${data.firstName || ""} ${data.lastName || ""}`.trim()
      );
      setImagePreview(data.image_url || data.image || "");
    }
  }, [data, mounted]);

  const handleUserName = (e) => {
    setUserName(e.target.value);
  };

  const handleImageFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result?.toString() || "");
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = () => {
    if (!rowId || !onUpdate) return;
    onUpdate({
      id: rowId,
      username: userName.trim(),
      image_url: imagePreview,
      image: imagePreview,
    });
    handleEditModalClose();
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              {" "}
              {data ? "Edit User" : "Add User"}{" "}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <Row>
            <Col md={12}>
              <p className="m-0">Image</p>
              {imagePreview ? (
                <div className="mt-2 mb-2 d-flex justify-content-center">
                  <img
                    src={imagePreview}
                    alt="User preview"
                    style={{
                      width: "72px",
                      height: "72px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid rgba(255,255,255,0.25)",
                    }}
                  />
                </div>
              ) : null}
              <input
                className="form-control mt-2 mb-3"
                type="file"
                accept="image/*"
                onChange={handleImageFile}
              />
            </Col>
          </Row>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <p className="m-0">Name</p>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="Enter user name"
                  value={userName}
                  onChange={handleUserName}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`${cssStyles.cardBtn} mt-4 `}
                  text={data ? "Update" : "Save"}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditUserModal;
